import React from "react";

import LoaderWebp from "../../assets/componentAssets/loading.webp";
import { useSelector } from "react-redux";

const Loading = () => {
  const { show, title } = useSelector((ctx) => ctx.loader);
  if (show)
    return (
      <div className="fixed w-full h-screen bg-[#000000c4] z-[9999] grid place-content-center">
        <div className="flex gap-4 flex-col items-center" >
          <img
            src={LoaderWebp} 
            className="w-14 h-14"
            alt="data is loading...."
          />
          {title && <p className="text-white">{title}</p>}
        </div>
      </div>
    );
};

export default Loading;
